<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-8">
               <h1>Subscription Code List</h1>
            </div>
            <!--<div class="col-xs-4">
               <router-link :to="{name: 'AddSubscriptionCode'}" class="btn btn-sm btn-add">
                  <i class="fa fa-plus-square"></i> Generate Subscription Code
               </router-link>
            </div>-->
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="dopagination(0)">
         <div class="row">
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Subscription Code" type="text" name="subscriptionCode" v-model="subscriptionCode" id="subscriptionCode" class="form-control input-sm" value="">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="idLots" id="lots_id" class="form-control input-sm select2" v-model="lots_id"  v-select="lots_id" @change="dopagination(0)">
                  <option value="0">Select Batch Name</option>
                  <option v-for="(data) in batchArr" :key="data.id" value="" :value="data.id">
                     {{data.name}}
                  </option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="status" id="status" v-model="status" v-select="status" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">All</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                 <!-- <option value="3">Subscribed</option>-->
               </select>
            </div>

            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="limit" id="limit" v-model="display_limit" v-select="display_limit" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-3 form-group pull-right btnRight">
               <button type="submit" class="btn btn-sm btn-submit">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>


         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <form>
                     <div class="box-header">
                        <h3 class="box-title">
                           Total : {{totalData}} Showing {{dispplayFrom}} to {{dispplayTo}}
                           <div class="form-inline pull-right" id="activation1">
                              <label style="color: green;font-weight: bold">With Selected</label>
                              <div class="form-group">
                                 <select title="" id="activation_option1" name="activation" class="form-control input-sm" v-model="operation_type">
                                    <option value="1">Activate</option>
                                    <option value="2">Deactivate</option>
                                 </select>
                              </div>
                              <input class="btn btn-sm btn-submit" type="button" name="button" value="Submit" @click="mulOperation(1)"/>
                           </div>
                        </h3>
                     </div>
                     <div class="box-body">
                        <div class="table-responsive">
                           <table class="table table-0024 table-bordered table-striped">
                              <thead>
                                 <tr>
                                    <th class="tdCenter tdSN">SN</th>
                                    <th class="tdCenter">Subscription Code</th>
                                    <th class="tdCenter">Batch Name</th>
                                    <th class="tdCenter">Created At</th>
                                    <th class="tdCenter">Used Date</th>
                                    <th class="tdCenter">Expire Date</th>
                                    <th class="tdCenter">Subscription</th>
                                    <th class="tdCenter">Used Subscriber</th>
                                    <th class="tdCenter">Is Used</th>
                                    <th class="tdCenter">Status</th>
                                    <th class="tdCenter">
                                       <span class="thSelectAll">Select</span>
                                       <input type="checkbox" id="check_all" @click="checkAll"/>
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="(data, index) in pinListArr" :key="data.id">
                                    <td class="tdCenter tdSN">
                                       {{parseInt(sl) + index}}
                                    </td>
                                    <td class="tdCenter">
                                          {{data.subscription_code}}
                                    </td>

                                    <td class="tdCenter">
                                       {{data.lot_name}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.created_at}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.used_at}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.expire_date}}
                                    </td>
                                    <td class="tdCenter info">
                                       {{data.plan_name}}
                                    </td>
                                    <td class="tdCenter">
                                       {{data.used_username}}
                                    </td>
                                    <td class="tdCenter" v-if="data.is_used==1">
                                       <span class='label label-success'>Yes</span>
                                    </td>
                                    <td class="tdCenter" v-else>
                                       <span class='label label-warning'>No</span>
                                    </td>
                                    <td class="tdCenter" v-if="data.is_active==1">
                                       <span class='label label-success'>Active</span>
                                    </td>
                                    <td class="tdCenter" v-else>
                                       <span class='label label-danger'>Inactive</span>
                                    </td>
                                    <td class="tdCenter">
                                       <input type="hidden" :value="data.is_active">
                                       <input class="user_id" name="user_id[]" type="checkbox" :value="data.id"/>
                                    </td>

                                 </tr>
                                 <tr v-if="pinListArr.length==0">
                                    <td colspan="17" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                            Found</b></td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>

                        <div class="pagination" v-if="last_page > 1">
                           <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                              « Previous
                           </a>
                           <span v-else class="disabled">« Previous</span>
                           <span v-if="last_page > max_display_pagination">
                              <span v-for="index in last_page">
                                 <span v-if="index==1||index==2">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                    <span v-if="(index==2) && firstDotted">..</span>
                                 </span>
                                 <span v-if="randomPageNumber.includes(index)">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                                 <span v-if="index==last_page||index==last_page-1">
                                    <span v-if="(index==last_page-1) && lastDotted">
                                       ..
                                    </span>
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                              </span>
                           </span>
                           <span v-else>
                              <span v-for="index in last_page">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">{{index}}</a>
                                 </span>
                              </span>
                           </span>
                           <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                              Next »
                           </a>
                           <span v-else class="disabled">Next »</span>
                        </div>

                     </div>
                     <div class="box-footer"></div>
                  </form>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "SubscriptionCodeList",
      data() {
         return {
            userData : {},
            pinListArr : [],
            batchArr : {},
            reseller_list : {},
            subscriptionCode : '',
            batch_pin_serial : '',
            id_reseller : '',
            lots_id : 0,
            deviceArr : {},

            alert_message : '',
            dispplayFrom : 0,   
            dispplayTo : 0,  
            totalData : 0, 
            display_limit : 50,
            status:1,
            sl : 1,
            operation_type : 1,
            is_online : '',
            showDropdown : false,

            // Pagination Variables
            prev_page_url : false,
            next_page_url : false,
            last_page : 1,
            current_page : null,
            max_display_pagination : 9,
            randomPageNumber : {}, 
            firstDotted: false,
            lastDotted: false,
            prevPage : '',
            nextPage : '',
         }
      },
      created(){
         this.com_user_type_access([4], true);
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         this.userData = JSON.parse(decodedString);
         this.showDropdown = this.com_onlineReportAccess();
         var rootObject = this;
         loader.show();
         axios.get('subscription-batches').then(function (response) {
            rootObject.batchArr = response.data.batchData.data;
         })
         .catch(function (error) {
            rootObject.com_errorHandel(error);
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
         });


         loader.hide();
         //this.loadPinList();
      },
      methods: {
         loadPinList(){
            loader.show();
            var rootObject = this;
            axios.get('subscription-codes').then(function (response) {
               rootObject.populatePinListData(response);
            })
            .catch(function (error) {
               let alertmessage = "";
               for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               loader.hide();
               rootObject.com_errorHandel(error);
            });
         },

         dopagination(page_no = ''){
            loader.show();
            var rootObject = this;

            let querystr = 'subscriptionCode='+encodeURIComponent(this.subscriptionCode)+'&status='+this.status+'&paginate='+this.display_limit+'&batch_id='+this.lots_id+'&sl_of_batch_pin='+this.batch_pin_serial+'&id_reseller='+this.id_reseller+'&is_online='+this.is_online;

            if(page_no > 0){
               querystr +="&page="+page_no;
            }else{
               querystr +="&page=1";
            }
            //console.log(querystr);

            axios.get('subscription-codes?'+querystr).then(function (response) {
               rootObject.populatePinListData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populatePinListData(response){
            this.sl = parseInt(response.data.from);

            var current_date_time = this.com_currentDateTime();
            var userData = this.userData;
            for (var prop in response.data.data) {
               var allowresetpin = false;
               var showPeriod = this.com_modifyDateTime(3, response.data.data[prop]['after_activate_first_subscriptionCode_at']);
               response.data.data[prop]['allowresetpin'] = allowresetpin;
            }
            this.pinListArr = response.data.data;
            //console.log(this.pinListArr);

            this.totalData = response.data.total;
            this.dispplayFrom = response.data.from;
            this.dispplayTo = response.data.to;
            this.display_limit = response.data.per_page;
            this.paginationGenerate(response);
            loader.hide();
         },

         paginationGenerate(response){
            this.prev_page_url = response.data.prev_page_url;
            this.next_page_url = response.data.next_page_url;
            this.last_page = response.data.last_page;
            this.current_page = response.data.current_page;
            this.randomPageNumber = [];
            this.firstDotted = false;
            this.lastDotted = false;
            this.prevPage = this.current_page-1;
            this.nextPage = this.current_page+1;
            let countableOtherPages = this.max_display_pagination-4;
            if(this.current_page==1 || this.current_page ==2){
               for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                  this.randomPageNumber.push(i);
               }
               this.lastDotted=true;
            }
            else if(this.current_page==this.last_page || this.current_page ==this.last_page-1){
               let endPage = this.last_page-2;
               for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                  this.randomPageNumber.push(i);
               }
               this.firstDotted = true;
            }
            else{
               let interval = parseInt(countableOtherPages / 2);
               if(this.current_page <= (interval+3)){
                  for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                     this.randomPageNumber.push(i);
                  }
                  this.lastDotted=true;
               }
               else if (this.current_page >= (this.last_page - (interval+2))) 
               {
                  let endPage = this.last_page-2;
                  for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                     this.randomPageNumber.push(i);
                  }
                  this.firstDotted = true;
               }else{
                  for(let i = this.current_page; i <= (this.current_page+interval); i++){
                     this.randomPageNumber.push(i);
                  }

                  for(let i = (this.current_page-1); i >= (this.current_page-interval); i--){
                     this.randomPageNumber.push(i);
                  }
               }
            }
            //console.log(this.randomPageNumber);
         },


         checkAll(){
            if($("#check_all").prop("checked")==true){
               $('.user_id').prop('checked', 'checked');
            }else{
               $('.user_id').prop('checked', false);
            }
         },

         mulOperation(type){
            var rootObject = this;

            var checked = document.querySelectorAll('input[name="user_id[]"]:checked').length;
            if (checked == 0) {
               $.alert('Please select at least a PIN');
               return;
            }

            /*status count message start*/
            var activePins = [];
            var inActivePins = [];
            var active_count = 0;
            var inactive_count = 0;
            $('input[name="user_id[]"]:checked').each(function () {
               const status = $(this).prev().val();
               if (status == 1) {
                  active_count += 1;
                  activePins.push($(this).val());
               } else {
                  inactive_count += 1;
                  inActivePins.push($(this).val());
               }
            });
            var activate_message = (active_count > 0) ? `${active_count} Subscription code's is active.` : '';
            var in_activate_message = (inactive_count > 0) ? `${inactive_count} Subscription code's is Inactive.` : '';
            /*status count message end*/

            var activation_option = this.operation_type;

            if(activation_option==1){
               if (inactive_count < 1) {
                  $.alert("All Subscription code's are already active.");
                  return;
               } else {
                  var msg = ` ${activate_message} ${in_activate_message} Are you sure you want to activate ${inactive_count} Subscription code's?`;
               }

               var users = inActivePins;
            }

            if(activation_option == 2){
               if (active_count < 1) {
                  $.alert("All Subscription code's are already Inactive.");
                  return;
               } else {
                  var msg = `${in_activate_message} ${activate_message} Are you sure you want to deactivate ${active_count} Subscription code's?`;
               }

               var users = activePins;
            }

            //console.log(users);

            $.confirm({
               title: 'Confirm!',
               content: msg,
               buttons: {
                  yes: function () {
                     loader.show();
                     const form = new FormData()
                     form.append('operation_type', activation_option)
                     form.append('codes', JSON.stringify(users))
                     var config = {
                        headers: { 'Content-Type': 'multipart/form-data' }
                     }
                     axios.post('bulk-subscription-codes-operation', form, config).then(function (response) {
                        //console.log(response);
                        if(response.status==200){
                           rootObject.dopagination(0);
                           rootObject.alert_message = "Subscriber\'s "+response.data;
                           rootObject.checkAll();
                           loader.hide();
                           setTimeout(function(){
                              rootObject.alert_message = '';
                           }, 3000);
                        }
                     })
                     .catch(function (error) {
                        rootObject.com_errorHandel(error);
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' '+error.response.data[prop]
                        }
                        //console.log(alertmessage);
                        $.alert(alertmessage);
                     });
                  },
                  no: function () {
                     return;
                  }
               }
            });

            //console.log(this.operation_type);
         },


         refreshNow(){
            this.subscriptionCode = '';
            this.batch_pin_serial = '';
            this.id_reseller = '';
            this.lots_id = 0;
            this.display_limit = 50;
            this.status = 1;
            this.last_page = 1;
            this.pinListArr = [];
         },

      },

      mounted: function() {
         var rootObject = this;
         $("#lots_id").on('change', function(){
            $('#batch_pin_serial').val('');
            if(this.value != 0){
               $('#batch_pin_serial').attr('disabled', false);
            }else{
               $('#batch_pin_serial').val('').attr('disabled', true);
            }
         });

         $(".select2").select2();
      }
      

   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>